import { addCoreFollowedIdMapSlice } from './add';
import { combineReducers } from 'redux';
import { defaultFollowedIdMapState } from './state';
import { joinSyncReducers } from '@sonar-software/xuder';
import { removeCoreFollowedIdMapSlice } from './remove';

export const coreFollowedIdMapReducers = combineReducers({
	read: joinSyncReducers(
		[
			addCoreFollowedIdMapSlice.syncReducer,
			removeCoreFollowedIdMapSlice.syncReducer
		],
		defaultFollowedIdMapState
	)
});
